import React, { useEffect } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";

const AuthFeature = () => {
  const location = useLocation();
  const [isError, setIsError] = React.useState(false);

  // Verifica o tipo de página e aplica o estilo adequado
  useEffect(() => {
    const layoutPages = location.pathname === "/under-maintenance" || location.pathname === "/error-404" || location.pathname === "/error-500";

    // Condiciona o estilo de erro
    if (layoutPages) {
      document.body.classList.add('bg-primary-transparent');
      setIsError(true);
    } else {
      setIsError(false);
      document.body.classList.remove('bg-primary-transparent');
    }

    return () => {
      // Limpeza do estilo após a navegação
      document.body.classList.remove('bg-primary-transparent');
    };
  }, [location.pathname]);

  // Página de "coming soon" com um layout específico
  const comingSoon = location.pathname === "/pages/coming-soon";

  return (
    <>
      {/* Se for uma página de erro, renderiza apenas o Outlet */}
      {isError ? (
        <Outlet />
      ) : (
        <div className={`main-wrapper authentication-wrapper ${comingSoon ? 'coming-soon-wrapper' : ''}`}>
          <div className="container-fluid">
            <Outlet />
          </div>
          <div className="copyright-footer">
            <p className="fs-14">
              Copyright &copy; 2025. Todos os direitos reservados, <Link to="#" className="text-primary fw-medium">DreamsTour</Link>
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default AuthFeature;
